import { render, staticRenderFns } from "./RelatedArticles.vue?vue&type=template&id=67afd2b4&"
import script from "./RelatedArticles.vue?vue&type=script&lang=js&"
export * from "./RelatedArticles.vue?vue&type=script&lang=js&"
import style0 from "./RelatedArticles.vue?vue&type=style&index=0&id=67afd2b4&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports